jQuery(document).ready(function ($) {
  $.getJSON(
    "https://geolocation-db.com/json/697de680-a737-11ea-9820-af05f4014d91",
    function (data) {
      var my_country = data.country_code;
      console.log("Country code is " + my_country);
      if (my_country != "US") {
        if (getCookie("popupCookie") != "yes") {
          if (getCookie("popupCookie") != "no") {
            $(".popup-overlay").css("display", "flex").hide().fadeIn();
          }
        }

        $(".close-btn").click(function () {
          $(".popup-overlay").fadeOut();
          setCookie("popupCookie", "no", 0.00069444444);
        });

        $(".submit-btn").click(function () {
          $(".popup-overlay").fadeOut();
          setCookie("popupCookie", "yes", 0.0034722222);
          var url = "https://uk.craftdlondon.com/";
          $(location).attr("href", url);
        });

        $("body").click(function () {
          $(".popup-overlay").fadeOut();
          setCookie("popupCookie", "no", 0.00069444444);
        });
      }
    }
  );

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function myTimer() {
    var ending = jQuery("#timer").attr("data-endtime"),
      endTime = new Date(ending);
    endTime = Date.parse(endTime) / 1000;

    var now = new Date();
    now = Date.parse(now) / 1000;

    var timeLeft = endTime - now;

    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    var seconds = Math.floor(
      timeLeft - days * 86400 - hours * 3600 - minutes * 60
    );

    if (days < "10") {
      days = "0" + days;
    }
    if (days < "1") {
      days = "0";
    }
    if (hours < "10") {
      hours = "0" + hours;
    }
    if (hours < "1") {
      hours = "0";
    }
    if (minutes < "10") {
      minutes = "0" + minutes;
    }
    if (minutes < "1") {
      minutes = "0";
    }
    if (seconds < "10") {
      seconds = "0" + seconds;
    }
    if (seconds < "1") {
      seconds = "0";
    }

    $("#timer").html(
      "<span id='hours'>" +
        hours +
        "<span>Hrs</span></span>" +
        "<span class='clone'>:</span>" +
        "<span id='minutes'>" +
        minutes +
        "<span>Mins</span></span>" +
        "<span class='clone'>:</span>" +
        "<span id='seconds'>" +
        seconds +
        "<span>Secs</span></span>"
    );
  }

  setInterval(function () {
    myTimer();
  }, 1000);

  $(".collapsiable_item:nth-child(1) .collapsiable_action_btn").addClass(
    "active"
  );
  $(".collapsiable_item:nth-child(1) .collapsiable_content").slideDown();
  $(".collapsiable_action_btn").on("click", function () {
    // if($(this).hasClass('active')) {
    // $(this).siblings('.collapsiable_content').slideUp();
    // $(this).removeClass('active');
    // }
    // else {
    // $('.collapsiable_content').slideUp();
    // $('.collapsiable_action_btn').removeClass('active');
    $(this).siblings(".collapsiable_content").slideToggle();
    $(this).toggleClass("active");
    // }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("variant:change", function (e) {
    var variant = e.detail.variant.id;
    var stickyBar = document.querySelector("product-sticky-bar");

    if (stickyBar) stickyBar.querySelector('[name="id"]').value = variant;
  });
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-slider]").forEach((slider) => {
    let ts;
    let sliderOptions;
    const options = JSON.parse(slider.getAttribute("data-slider"));
    if (options.controls && options.controlsContainer) {
      sliderOptions = {
        container: slider.querySelector(".slider-items"),
        controlsContainer: slider.querySelector(".slider-controls"),
        ...options,
      };
    } else if (options.controls) {
      sliderOptions = {
        container: slider.querySelector(".slider-items"),
        controlsContainer: slider.nextElementSibling,
        ...options,
      };
    } else {
      sliderOptions = {
        container: slider.querySelector(".slider-items"),
        ...options,
      };
    }
    console.log(sliderOptions);
    ts = tns(sliderOptions);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const menuOverlay = document.querySelector(".menu-overlay");
  let isOverMegaMenu = false;

  const menuItemsWithMegaMenu = document.querySelectorAll(
    ".header__primary-nav-item details"
  );

  menuItemsWithMegaMenu.forEach(function (menuItem) {
    menuItem.addEventListener("mouseenter", function () {
      if (
        menuItem.querySelector(".mega-menu") &&
        !document.querySelector("#header-search[open]")
      ) {
        isOverMegaMenu = true;
        menuOverlay.classList.add("visible");
      } else {
        isOverMegaMenu = false;
        setTimeout(() => {
          if (!isOverMegaMenu) {
            menuOverlay.classList.remove("visible");
          }
        }, 250);
      }
    });

    menuItem.addEventListener("mouseleave", function () {
      if (menuItem.querySelector(".mega-menu")) {
        isOverMegaMenu = false;
        setTimeout(() => {
          if (!isOverMegaMenu) {
            menuOverlay.classList.remove("visible");
          }
        }, 250);
      }
    });
  });

  menuOverlay.addEventListener("mouseenter", function () {
    isOverMegaMenu = false;
    setTimeout(() => {
      if (!isOverMegaMenu) {
        menuOverlay.classList.remove("visible");
      }
    }, 250);
  });

  menuOverlay.addEventListener("mouseleave", function () {
    isOverMegaMenu = false;
    setTimeout(() => {
      if (!isOverMegaMenu) {
        menuOverlay.classList.remove("visible");
      }
    }, 250);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-quick-filter]").forEach((quickFilter) => {
    quickFilter.addEventListener("click", (e) => {
      const filterValue = quickFilter.getAttribute("data-quick-filter");
      const facetFilters = document.querySelectorAll(
        `[data-filter="${filterValue}"]`
      );
      facetFilters.forEach((facetFilter) => {
        facetFilter.querySelector("label").click();
      });
      quickFilter.classList.toggle("active");
      // document.querySelector('facets-drawer [slot="footer"] button').click();
    });
  });

  document.addEventListener("click", (e) => {
    if (e.target.matches("[data-remove-filter]")) {
      const removeFilter = e.target;
      const filterValue = removeFilter.getAttribute("data-remove-filter");
      const quickFilter = document.querySelector(
        `[data-quick-filter="${filterValue}"]`
      );

      if (quickFilter) {
        quickFilter.classList.toggle("active");
      }
    }
  });
});

function productCard(initialState) {
  return {
    ...initialState,

    init() {
      this.$watch("showAtc", (value) => {
        window.dispatchEvent(new CustomEvent("quick-add-overlay"));
      });

      tns({
        container: this.$refs.slider,
        items: 1,
        controls: true,
        controlsContainer: this.$refs.sliderControls,
        nav: true,
        navPosition: "bottom",
      });
    },
  };
}

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("filter-sort-button")) {
    var value = e.target.value;
    var targetButton = document.querySelector(
      `button.popover-listbox__option[value="${value}"]`
    );
    if (targetButton) {
      targetButton.click();
    }
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const configElement = document.querySelector('[data-rebuy-api-key]');

//   if (!configElement) return;

//   const API_KEY = configElement.dataset.rebuyApiKey;
//   const RULESET_ID = configElement.dataset.rebuyRuleId;

//   document.addEventListener('cart:refresh', (event) => {
//     if (event.detail && event.detail.cart) {
//       rebuildUpsell(event.detail.cart, API_KEY, RULESET_ID);
//     }
//   });

//   document.addEventListener('rebuy:cart.change', function(event) {
//     rebuildUpsell(event.detail.cart.cart, API_KEY, RULESET_ID);
//   });
// });

function rebuildUpsell(cart, API_KEY, RULESET_ID, limit = 10) {
  if (!API_KEY || !RULESET_ID) return;

  const params = new URLSearchParams();
  params.append('key', API_KEY);
  params.append('limit', limit);
  params.append('metafields', 'yes');
  params.append('bust_cache', 'yes');

  if (cart.items.length > 0) {
    params.append('shopify_product_ids', cart.items.map(i => i.product_id).join(','));
    params.append('shopify_variant_ids', cart.items.map(i => i.variant_id).join(','));
  }

  params.append('cart_subtotal', cart.total_price);
  params.append('cart_line_count', cart.item_count);

  cart.items.forEach((item, i) => {
    params.append(`cart[items][${i}][product_id]`, item.product_id);
    params.append(`cart[items][${i}][variant_id]`, item.variant_id);
    params.append(`cart[items][${i}][quantity]`, item.quantity);
  });

  const url = `https://rebuyengine.com/api/v1/custom/id/${RULESET_ID}?${params.toString()}`;

  fetch(url)
    .then(response => response.json())
    .then(response => {
      window.dispatchEvent(new CustomEvent('upsell-data-ready', {
        detail: {
          products: response.data,
          view: response.metadata.custom?.view || 'atc',
          title: response.metadata.custom?.title || 'Complete the look',
          description: response.metadata.custom?.description || null,
          discount: response.metadata.custom?.discount || null
        }
      }));
    });
}

function atc(variantId, properties = {}) {
  if (!variantId) return;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        properties: properties
      }]
    })
  })
  .then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(data => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  })
  .catch((error) => {
    alert('Error: please try again');
    console.error('Error adding to cart:', error);
  });
}
// CRO: cart drawer self-heal. On slow connections two overlapping
// cart:refresh section renders can apply out of order, leaving the drawer
// showing a stale "empty" state while the cart has items (reported on
// mobile). After each refresh settles, verify the drawer matches /cart.js
// and force one more refresh if not. Capped to avoid loops.
(function () {
  var attempts = 0;
  var timer = null;
  document.addEventListener('cart:refresh', function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var drawer = document.getElementById('cart-drawer');
          if (!drawer) return;
          var hasItemsDom = !!drawer.querySelector('.cart-drawer__items');
          var mismatch = (cart.item_count > 0 && !hasItemsDom) || (cart.item_count === 0 && hasItemsDom);
          if (mismatch && attempts < 3) {
            attempts += 1;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else if (!mismatch) {
            attempts = 0;
          }
        })
        .catch(function () {});
    }, 1600);
  });
})();

// CRO: locale-aware post-ATC redirect (Danny, 20 Aug 2026; scoped 21 Aug).
// The PDP form dispatches 'toggle-cart-drawer' after adding; the site's
// behaviour there is a hard redirect to /cart, which drops the language
// prefix (/de-de -> /cart). Intercept in the capture phase and redirect via
// Shopify.routes.root, which carries the locale. SCOPE: only for events
// coming from the PDP - quick-add from collection/homepage cards (.gs-card)
// is left alone so the '+' opens the cart drawer instead of yanking the
// shopper off the grid mid-browse.
(function () {
  document.addEventListener('toggle-cart-drawer', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gs-card')) return;
    e.stopImmediatePropagation();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'cart';
  }, true);
})();
